export default __webpack_public_path__ + "static/media/jgbqImg.fb904507.png";